/**
 * @generated SignedSource<<fbb5ea9c51b0fae626ee95bb403100d5>>
 * @relayHash 2b8c5b33a32f99332021bfad72fb9f42
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2b8c5b33a32f99332021bfad72fb9f42

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type ReferralReason = "APPOINTMENT_POST_REGISTRATION" | "APPOINTMENT_REGISTRATION" | "EMERGENCY_POST_REGISTRATION" | "EMERGENCY_REGISTRATION" | "REFERRAL";
export type ReferredBy = "CARE_PROVIDER" | "MEDGATE" | "SELF";
export type Ch_createTimeWindowInput = {
  alternativeTriageData?: AlternativeTriageWithTimeWindowInput | null;
  dateFrom: any;
  dateTo: any;
  errorCorrection?: boolean | null;
  inboundCallId?: number | null;
  internalComment?: string | null;
  involvesPreventionProgram: boolean;
  patientId: string;
  referenceDate?: any | null;
  referralReason: ReferralReason;
  referralToCareProviderId?: string | null;
  referralToDoctorName?: string | null;
  referredBy: ReferredBy;
  referredByExternalCareProviderId?: string | null;
};
export type AlternativeTriageWithTimeWindowInput = {
  language: Language;
  phoneNumber: string;
  reason: string;
};
export type useChCreateTimeWindowMutation$variables = {
  input: Ch_createTimeWindowInput;
};
export type useChCreateTimeWindowMutation$data = {
  readonly ch_createTimeWindow: {
    readonly ch_TimeWindow: {
      readonly alternativeTriage: boolean | null;
      readonly alternativeTriageEntry: {
        readonly id: string;
        readonly phoneNumber: string;
        readonly reason: string;
      } | null;
      readonly dateFrom: any;
      readonly dateTo: any;
      readonly id: string;
      readonly internalComment: string | null;
      readonly patientId: string;
      readonly progressNote: {
        readonly appointment: {
          readonly id: string;
          readonly language: Language;
        };
        readonly episodeOfCareId: string | null;
        readonly id: string;
        readonly pointOfCare: {
          readonly careProviderId: number | null;
        } | null;
        readonly treatmentPlan: {
          readonly followUpInstructions: string | null;
          readonly from: any;
          readonly recommended: string | null;
          readonly title: string;
          readonly to: any;
        } | null;
      } | null;
      readonly progressNoteId: string | null;
      readonly referralReason: ReferralReason;
      readonly referralToCareProviderId: string | null;
      readonly referralToDoctorName: string | null;
      readonly referredBy: ReferredBy;
      readonly referredByExternalCareProviderId: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useChCreateTimeWindowMutation = {
  response: useChCreateTimeWindowMutation$data;
  variables: useChCreateTimeWindowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_TimeWindow",
  "kind": "LinkedField",
  "name": "ch_TimeWindow",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateFrom",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateTo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralToDoctorName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referredBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralReason",
      "storageKey": null
    },
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalComment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralToCareProviderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referredByExternalCareProviderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeTriage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ch_ProgressNote",
      "kind": "LinkedField",
      "name": "progressNote",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "episodeOfCareId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Appointment",
          "kind": "LinkedField",
          "name": "appointment",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "language",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ch_PointOfCare",
          "kind": "LinkedField",
          "name": "pointOfCare",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "careProviderId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TreatmentPlan",
          "kind": "LinkedField",
          "name": "treatmentPlan",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "followUpInstructions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recommended",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "from",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "to",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ch_AlternativeTriage",
      "kind": "LinkedField",
      "name": "alternativeTriageEntry",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChCreateTimeWindowMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createTimeWindowPayload",
        "kind": "LinkedField",
        "name": "ch_createTimeWindow",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChCreateTimeWindowMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createTimeWindowPayload",
        "kind": "LinkedField",
        "name": "ch_createTimeWindow",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "2b8c5b33a32f99332021bfad72fb9f42",
    "metadata": {},
    "name": "useChCreateTimeWindowMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4751a1f393aefac98a27584d21f8d5f8";

export default node;
